import React, { useState, useEffect } from 'react';
import { supabase } from '../../services/supabase';

const ManageAnnouncements = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    isPinned: false
  });

  const fetchAnnouncements = async () => {
    const { data, error } = await supabase
      .from('announcements')
      .select('*')
      .order('createdAt', { ascending: false });
      
    if (!error && data) {
      setAnnouncements(data);
    } else {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let imageUrl = null;
      if (imageFile) {
        const filePath = `${Date.now()}_${imageFile.name}`;
        const { error: uploadError } = await supabase.storage
          .from('announcements')
          .upload(filePath, imageFile);
          
        if (uploadError) throw uploadError;
        
        const { data: publicUrlData } = supabase.storage
          .from('announcements')
          .getPublicUrl(filePath);
          
        imageUrl = publicUrlData.publicUrl;
      }

      const { data: userData } = await supabase.auth.getUser();
      const user = userData.user;

      const { error: insertError } = await supabase.from('announcements').insert([{
        title: formData.title,
        content: formData.content,
        isPinned: formData.isPinned,
        imageUrl,
        category: 'announcements',
        createdAt: new Date().toISOString(),
        userId: user?.id || 'admin',
        displayName: user?.email || 'Admin',
        likeCount: 0,
        commentCount: 0,
        isApproved: true,
      }]);
      
      if (insertError) throw insertError;
      alert('Announcement Posted!');
      setFormData({ title: '', content: '', isPinned: false });
      setImageFile(null);
      // Reset the file input field
      document.getElementById('imageUpload').value = '';
      fetchAnnouncements();
    } catch (error) {
      console.error("Error adding document: ", error);
      alert('Failed to post announcement');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if(window.confirm('Are you sure you want to delete this announcement?')) {
      await supabase.from('announcements').delete().eq('id', id);
      fetchAnnouncements();
    }
  };

  return (
    <div className="admin-page">
      <h1>Manage Announcements</h1>
      <p>Here you will be able to post announcements directly to the mobile app.</p>
      
      <div className="admin-split-layout">
        <div className="admin-form-card">
          <h3>Post New Announcement</h3>
          <form onSubmit={handleSubmit} className="admin-form">
            <div className="form-group">
              <label>Title</label>
              <input type="text" name="title" value={formData.title} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Message Content</label>
              <textarea name="content" value={formData.content} onChange={handleChange} required style={{padding: '0.75rem', borderRadius: '0.375rem', border: '1px solid #d1d5db', minHeight: '150px'}} />
            </div>
            <div className="form-group">
              <label>Event Image (Optional)</label>
              <input type="file" id="imageUpload" accept="image/*" onChange={(e) => setImageFile(e.target.files[0])} style={{padding: '0.5rem', borderRadius: '0.375rem', border: '1px solid #d1d5db'}} />
            </div>
            <div className="form-group" style={{ flexDirection: 'row', alignItems: 'center', gap: '0.5rem' }}>
              <input type="checkbox" name="isPinned" checked={formData.isPinned} onChange={handleChange} />
              <label>Pin to top?</label>
            </div>
            <button type="submit" disabled={loading} className="admin-btn">
              {loading ? 'Posting...' : 'Post Announcement'}
            </button>
          </form>
        </div>

        <div className="admin-list-card">
          <h3>Recent Announcements</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {announcements.map(item => (
              <li key={item.id} style={{ background: '#fff', padding: '1rem', marginBottom: '1rem', borderRadius: '0.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <h4 style={{ margin: '0 0 0.5rem 0' }}>{item.isPinned && '📌 '} {item.title}</h4>
                    {item.imageUrl && (
                      <img src={item.imageUrl} alt={item.title} style={{ maxWidth: '100px', borderRadius: '4px', marginBottom: '0.5rem' }} />
                    )}
                    <p style={{ margin: '0 0 0.5rem 0', color: '#4b5563', fontSize: '0.9rem' }}>{item.content}</p>
                    <p style={{ margin: '0', fontSize: '0.75rem', color: '#9ca3af' }}>
                      {new Date(item.createdAt).toLocaleString()} by {item.displayName}
                    </p>
                  </div>
                  <button onClick={() => handleDelete(item.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontWeight: 'bold' }}>Delete</button>
                </div>
              </li>
            ))}
            {announcements.length === 0 && <p style={{color: '#6b7280'}}>No announcements posted yet.</p>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ManageAnnouncements;
